<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
          <div class='h-inputLit'>
            <span>{{$t('Pui.pui')}}</span>
          </div>
              <div v-for="(pui, index) in puiList" :key="index">

          <input class="e-input" :value='pui' disabled="true"/>
      </div>
    </div>
    </div>
    <br>
    <div class="h-borderBox">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='400px' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column field='pvi' clipMode='EllipsisWithTooltip' :headerText='$t("Pui.pvi")' width='200' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: 'QryPuiDialog',
  components: {
  },
  data() {
    return {
      data: [],
      // pui: '',     
      puiList: [],     
    };
  },
  methods: {
    getPuiListByPui(record,neid) {
      const checkedRecord = {
        ...record[0],
      };
      console.log('checkedRecord',checkedRecord);
      const params = {
        info: {
          neid: neid,
          msgid: "30490"
        },
        vo: {
            "pui": checkedRecord.pui,
            "pvi": "",
        },
      };
      this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
        const res = response.data;
        this.puiList=res.resultVal.puiList;
        const dataSource = res.resultVal.pvi;//暂时一个PVI对应多个PUI ；一个pui对应一个PVI
        const dataArray = [];
        // for(let i=0;i<dataSource.length;i++){
        //   const param={pvi:dataSource[i]};
        //   dataArray.push(param);
        // }
        const param={pvi:dataSource};
        dataArray.push(param);
        this.data= dataArray;
      });

    },
  },
};
</script>

<style scoped>

</style>
